export default axios => ({
  getUsers () {
    return axios.get('/user/')
  },
  getLight (payload) {
    return axios.get('/user/', payload)
  }
})
